/**
 * 网络请求配置
 */
import axios from "axios";
import {  Dialog } from '@nutui/nutui-react';
import { Toast } from 'zarm';
import $ from 'jquery'
import '../static/css/index.css'

let ip = ""

$.ajax({
    type: 'get',
    async: false,
    url: '/ip/ip.json',
    data: {},
    success: (res) => {
        // alert(JSON.stringify(res))
        ip = res.ip
    }
})

let lang = localStorage.getItem('language') ? localStorage.getItem('language') : 'en-US'
const instance = axios.create({
    baseURL: ip,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'userToken': localStorage.getItem('userToken'),
        'lang': lang,
        'sdmUserId': localStorage.getItem("userId")
    }
});


/**
 * http request 拦截器
 */
instance.interceptors.request.use(
    (config) => {
        config.data = JSON.stringify(config.data);
        config.headers = {
            "Content-Type": "application/json",
            'userToken': localStorage.getItem('userToken'),
            'lang': lang,
            'sdmUserId': localStorage.getItem("userId")
        };

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 * http response 拦截器
 */
instance.interceptors.response.use(
    (response) => {
        if (response.data.errCode === 2) {
            console.log("expired");
        }
        return response;
    },
    (error) => {
        console.log("Request error:", error);
    }
);

/**
 * 封装get方法
 * @param url  请求url
 * @param params  请求参数
 * @returns {Promise}
 */




export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params: params,
        }).then((response) => {
            landing(url, params, response.data);
            resolve(response.data);
        })
            .catch((error) => {
                reject(error);
            });
    });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data) {
    return new Promise((resolve, reject) => {
        instance.post(url, data).then(
            (response) => {
                //关闭进度条
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        instance.patch(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                msag(err);
                reject(err);
            }
        );
    });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        instance.put(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                msag(err);
                reject(err);
            }
        );
    });
}

const Authenticationfailed = () => {
    let msg = ''
    let confirm = ''
    if (lang == 'zh') {
        msg = '登录过期，请重新登录'
        confirm = '确认'
    } else {
        msg = 'Login expired, please log in again'
        confirm = 'confirm'
    }

    Dialog.alert({
        content: msg,
        confirmText: confirm,
        hideCancelButton: true,
        onConfirm: (e) => {
            localStorage.removeItem('code')
            window.history.replaceState("", "", '/empower');
            window.history.go(0);
        }
    });
}



//统一接口处理，返回数据
export default function (fecth, url, param) {
    let _data = "";
    return new Promise((resolve, reject) => {
        switch (fecth) {
            case "get":
                get(url, param)
                    .then(function (response) {
                        if (response.code == 200) {
                            resolve(response);
                        } else if (response.code == 401) {
                            console.log(response.msg)
                            Authenticationfailed()
                        } else {
                            Toast.show(response.msg);
                        }
                    })
                    .catch(function (error) {

                        reject(error);
                    });
                break;
            case "post":
                post(url, param)
                    .then(function (response) {
                        if (response.code == 200) {
                            resolve(response);
                        } else if (response.code == 401) {
                            Authenticationfailed()
                        } else {
                            Toast.show(response.msg);
                        }


                    })
                    .catch(function (error) {

                        reject(error);
                    });
                break;
            case "put":
                put(url, param)
                    .then(function (response) {
                        if (response.code == 200) {
                            resolve(response);
                        } else if (response.code == 401) {
                            Authenticationfailed()
                        } else {
                            Toast.show(response.msg);
                        }
                    })
                    .catch(function (error) {
                        reject(error);
                    });
                break;
            default:
                break;
        }
    });
}

//失败提示
function msag(err) {
    if (err && err.response) {
        switch (err.response.status) {
            case 400:
                alert(err.response.data.error.details);
                break;
            case 401:
                alert("未授权，请登录");
                break;

            case 403:
                alert("拒绝访问");
                break;

            case 404:
                alert("请求地址出错");
                break;

            case 408:
                alert("请求超时");
                break;

            case 500:
                alert("服务器内部错误");
                break;

            case 501:
                alert("服务未实现");
                break;

            case 502:
                alert("网关错误");
                break;

            case 503:
                alert("服务不可用");
                break;

            case 504:
                alert("网关超时");
                break;

            case 505:
                alert("HTTP版本不受支持");
                break;
            default:
        }
    }
}

/**
 * 查看返回的数据
 * @param url
 * @param params
 * @param data
 */
function landing(url, params, data) {
    if (data.code === -1) {
    }
}

